import { useTranslation } from 'react-i18next'

import { Card, CardTitle, Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const LineItemsToReturnCardSkeleton = () => {
  const { t } = useTranslation()

  return (
    <Card showBorder={false}>
      <CardTitle>{t('Productos a devolver')}</CardTitle>
      <Styles.ItemsContainer>
        <Styles.LineItem>
          <Styles.LineItemBody>
            <Skeleton variant="rounded" width={100} height={20} />
            <Skeleton variant="text" width={80} height={14} />
            <Styles.ProductRow>
              <Skeleton variant="rounded" width={88} height={88} />
              <Styles.ProductInfo>
                <Skeleton variant="text" width={140} height={20} />
                <Skeleton variant="text" width={100} height={14} />
                <Skeleton variant="text" width={70} height={20} />
              </Styles.ProductInfo>
            </Styles.ProductRow>
          </Styles.LineItemBody>
          <Styles.ReasonBanner>
            <Skeleton variant="rounded" width={120} height={16} />
            <Skeleton variant="rounded" width={220} height={14} />
          </Styles.ReasonBanner>
        </Styles.LineItem>
      </Styles.ItemsContainer>
      <Skeleton variant="rounded" width="100%" height={48} />
    </Card>
  )
}

export default LineItemsToReturnCardSkeleton
